import { httpService } from '@/services/HttpService';

class UsersService {
  getUsers(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/settings/users`);
  }
  getAuditLogs(workspaceId: number, page: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/audit_logs?page=${page}`);
  }
  getLogsFilteredDate(workspaceId: number, page: number, dateFrom: string, dateTo: string): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/audit_logs?page=${page}&start_date=${dateFrom}&end_date=${dateTo}`
    );
  }
  getCSVfile(workspaceId: number, dateFrom: string, dateTo: string): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/audit_logs/csv?start_date=${dateFrom}&end_date=${dateTo}`);
  }
  deleteUser(workspaceId: number, userId: number): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/settings/users/${userId}`, '');
  }
  deleteInvitation(workspaceId: number, invitationId: number): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/settings/users/invitations/${invitationId}`, '');
  }
  createInvitation(workspaceId: number, email: string, role: string): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/settings/users/invitations`, { email, role });
  }
}

export const usersService = new UsersService();
